export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', () => {
      document.getElementById(this.dataset.dialogId).showModal()
    })
  }
}
